var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_4791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.54038 0.159839L2.21054 0.487403C2.10754 0.590493 2.05079 0.727648 2.05079 0.874234C2.05079 1.02074 2.10754 1.15806 2.21054 1.26115L5.94732 4.99776L2.2064 8.73869C2.10339 8.84162 2.04672 8.97893 2.04672 9.12544C2.04672 9.27195 2.10339 9.40934 2.2064 9.51235L2.53421 9.84C2.74738 10.0533 3.09462 10.0533 3.30779 9.84L7.77783 5.38598C7.88075 5.28305 7.95328 5.1459 7.95328 4.99809L7.95328 4.99638C7.95328 4.8498 7.88067 4.71264 7.77783 4.60971L3.3199 0.159839C3.21698 0.0567483 3.07567 0.000163033 2.92917 -3.8573e-08C2.78258 -3.21655e-08 2.64323 0.0567484 2.54038 0.159839Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_4791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 10) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.47daa8ce254c5d1f495640a7c008aa03.svg";
export { ForwardRef as ReactComponent };